import { t } from '@app/i18n';
import type { FailureCard, OverviewFailure } from './Overview.api';

/**
 * Degradação por card de T3 (FR-095, FR-126).
 *
 * O contrato manda `falhas[]` com o card afetado e o código; a frase da tela é
 * "não foi possível ler {fonte}", e **cada card** tem a sua fonte — dizer "não
 * foi possível ler os dados" seria verdade sem informação. Os demais cards
 * continuam preenchidos: `getOverview` nunca é 502.
 */
/**
 * Chave por **valor do contrato** (`security_ready`, `conexao`, …), snake_case
 * como o `error.*`: o que nomeia a chave é o dado que o servidor manda.
 */
function cardSource(card: FailureCard): string {
  return t(`overview.failure.source.${card}`);
}

export function cardFailure(
  falhas: readonly OverviewFailure[] | undefined,
  card: FailureCard,
): OverviewFailure | undefined {
  return falhas?.find((falha) => falha.card === card);
}

/**
 * "não foi possível ler decisões (rota_ausente)" — a frase do FR-095 com o
 * código técnico entre parênteses, como em todo erro do console (FR-123).
 * A frase do servidor, quando vem, entra depois: é ela que diz o porquê.
 */
export function failureText(falha: OverviewFailure): string {
  const base = t('overview.failure.text', {
    source: cardSource(falha.card),
    code: falha.code,
  });
  return falha.message ? t('overview.failure.detail', { base, message: falha.message }) : base;
}
